import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

const COLORS = ["#149B9E", "#FFC20E", "#FFFFFF", "#000000"];
const ORIGINS = 12;

export const useConfettiOnView = (photoRef) => {
  const fired = useRef(false);

  useEffect(() => {
    const el = photoRef.current;
    if (!el || fired.current) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const fire = () => {
      fired.current = true;
      const canvas = document.createElement("canvas");
      Object.assign(canvas.style, { position: "fixed", inset: "0", width: "100%", height: "100%", pointerEvents: "none", zIndex: "40", background: "transparent" });
      document.body.appendChild(canvas);
      const shoot = confetti.create(canvas, { resize: true, useWorker: true });

      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const rx = r.width / 2, ry = r.height / 2;
      const W = window.innerWidth, H = window.innerHeight;

      const shots = Array.from({ length: ORIGINS }, (_, i) => {
        const t = (i / ORIGINS) * Math.PI * 2;
        const px = cx + rx * Math.cos(t), py = cy + ry * Math.sin(t);
        const angle = (Math.atan2(-(py - cy), px - cx) * 180) / Math.PI;
        return shoot({
          particleCount: 15, angle, spread: 45, startVelocity: 35, ticks: 200, gravity: 0.9, scalar: 1,
          colors: COLORS, origin: { x: px / W, y: py / H }, disableForReducedMotion: true,
        });
      });
      Promise.all(shots).then(() => canvas.remove());
    };

    const threshold = window.innerHeight < el.getBoundingClientRect().height + 40 ? 0.8 : 0.98;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting) && !fired.current) {
        fire();
        io.disconnect();
      }
    }, { threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [photoRef]);
};
